'use client';

import {
	ModalStatusEnum,
	useModalStoreActions,
	useNotificationsStoreActions,
	useSettingsStoreActions,
	// useNotificationsStoreActions,
	useSideNavOpen,
} from '@/store';
import React, { useEffect, useState } from 'react';
import ds from '@/styles/ds/ds.module.scss';
import SectionDivider from '../SectionDivider/SectionDivider';
import { icons } from '@/Icons';

const SearchButton = () => {
	const sideNavOpen = useSideNavOpen();
	const { setSideNavOpen } = useSettingsStoreActions();
	const { setModalStatus } = useModalStoreActions();
	const [isMounted, setIsMounted] = useState(false);

	useEffect(() => {
		setIsMounted(true);
	}, []);

	const handleSearch = () => {
		const url = new URL(window.location.href);
		url.searchParams.set('search', 'true');
		window.history.pushState({}, '', url);
		setModalStatus(ModalStatusEnum.SearchModal);

		if (window.innerWidth < 768) {
			const elementId = 'sidenav';
			const element = document.getElementById(elementId);
			if (!element) return;

			element.classList.toggle('-translate-x-[100%]');
			element.classList.toggle('translate-x-0');
		}

		/* -------------------------------------------------------------------------- */
	};

	if (!isMounted || !sideNavOpen) return null;

	return (
		<>
			<section className="flex items-center justify-center px-2.5 pb-4 pt-6 sticky top-0 bg-midnight-blue z-50  ">
				<button
					aria-label="Search"
					className={`${ds['input-container']} min-h-10`}
					onClick={handleSearch}
				>
					<icons.searchicon className={`w-[15px] h-[15px] text-dove-white`} />
					<span aria-label="Search" className="text-dove-white ">
						Search
					</span>
				</button>
			</section>
			<SectionDivider />
		</>
	);
};

export default SearchButton;
